import {createRouter, createWebHistory} from 'vue-router';
import {useAPI, log} from 'taxi-lib'
import ReceiptDetail from "@hq-receipt/view/ReceiptDetail.vue";
import DefaultLayout from '@hq-receipt/layout/DefaultLayout.vue';

import NotFound from './view/NotFound.vue';

const routePrefix = '/receipt'

const routes = [
    {
        path: '/',
        redirect: `${routePrefix}/`
    },
    {
        path: `${routePrefix}/`,
        component: DefaultLayout,
        children: [
            {
                path: '',
                name: 'ReceiptEmpty',
                component: ReceiptDetail,
            },
            {
                path: ':id/:secret/',
                name: 'ReceiptDetail',
                component: ReceiptDetail,
                props: route => ({
                    id: route.params.id,
                    secret: route.params.secret,
                }),
            },
        ],
    },
    /*
      {
        path: `${routePrefix}/login/`,
        name: 'Login',
        component: Login,
        meta: {
          external: true
        },
      },
    */
    // Wildcard route for 404 page
    {
        path: '/:pathMatch(.*)*',
        component: NotFound,
    },
];

const router = createRouter({
    history: createWebHistory(),
    routes,
});

router.beforeEach((to, from, next) =>
{
    if (to.meta.external && import.meta.env.PROD)
    {
        window.location.href = to.fullPath; // Force a full page reload to the legacy page
    } else
    {
        next(); // Proceed with normal route navigation
    }
})

let api_setup = false
router.beforeEach(async (to, from) =>
{
    if (api_setup)
    {
        return
    }

    const {api} = useAPI();
    let url = "/api";
    api.set_auth({});
    api.set_url(url);
})

export default router;
